import { MagicDeckGroupCreatures } from "./groups/magic-deck-group-creatures";
import { MagicDeckGroupPlaneswalkers } from "./groups/magic-deck-group-planeswalkers";
import { MagicDeckGroupInstants } from "./groups/magic-deck-group-instants";
import { MagicDeckGroupSorceries } from "./groups/magic-deck-group-sorceries";
import { MagicDeckGroupEnchantments } from "./groups/magic-deck-group-enchantments";
import { MagicDeckGroupArtifacts } from "./groups/magic-deck-group-artifacts";
import { MagicDeckGroupLands } from "./groups/magic-deck-group-lands";
import { MagicDeckGroupTokens } from "./groups/magic-deck-group-tokens";
import { MagicDeckGroupOther } from "./groups/magic-deck-group-other";
import { MagicDeckGroupCommander } from "./groups/magic-deck-group-commander";
import { MagicDeckGroupOathbreaker } from "./groups/magic-deck-group-oathbreaker";
import { MagicDeckGroupSignatureSpells } from "./groups/magic-deck-group-signature-spells";
import { MagicDeckGroupBackground } from "./groups/magic-deck-group-background";
import { DeckGroups } from "@ponder-features/user/decks/deck/group/deck-groups";

export class MagicDeckGroups extends DeckGroups {
    protected override addDefaultGroups(): void {
        this.groups = [
            new MagicDeckGroupCreatures(),
            new MagicDeckGroupPlaneswalkers(),
            new MagicDeckGroupInstants(),
            new MagicDeckGroupSorceries(),
            new MagicDeckGroupEnchantments(),
            new MagicDeckGroupArtifacts(),
            new MagicDeckGroupLands(),
            new MagicDeckGroupTokens(),
            new MagicDeckGroupOther()
        ];
    }

    protected override addSpecializedGroups(): void {
        if (this.deck.type === "Commander") {
            this.groups.unshift(new MagicDeckGroupBackground());
            this.groups.unshift(new MagicDeckGroupCommander());
        } else if (this.deck.type === "Oathbreaker") {
            this.groups.unshift(new MagicDeckGroupSignatureSpells());
            this.groups.unshift(new MagicDeckGroupOathbreaker());
        }
    }
}